import React, { useCallback, useState } from 'react'
import RequestDialog from '../../dialogs/RequestDialog'
import { Button } from '@mui/material'
import { updateClassArchiveStatus } from 'shared/api/mutations'
import { useNotify } from 'shared/ui/Notify'

const ArchiveClassButton = ({
  id,
  level,
  archive,
  label,
}: {
  id: number
  level: string
  archive: boolean
  label: string
}) => {
  const [open, setOpen] = useState(false)
  const notify = useNotify()
  const archiveClasses = useCallback(async () => {
    const response = await updateClassArchiveStatus(id, level, archive)
    if (response.errors) {
      notify(response.errors[0].message, { type: 'error' })
    } else {
      notify((archive ? 'Archive' : 'Unarchive') + ' completed', {
        type: 'info',
      })
    }
  }, [id, level, archive, notify])
  const title =
    'Are you sure you want to ' + (archive ? 'archive' : 'unarchive') + '?'

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button
        variant="outlined"
        color="warning"
        onClick={handleClickOpen}
        style={{ margin: '5' }}
      >
        {label}
      </Button>
      <RequestDialog
        open={open}
        title={title}
        content={[]}
        submitRequest={archiveClasses}
        onClose={handleClose}
        refreshPopUp={true}
      />
    </>
  )
}

export default ArchiveClassButton
